// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Returns the form's action with its submitted fields as the query string. */
export function publishingDomainSwitchUrl(form) {
  return `${form.getAttribute("action")}?${new URLSearchParams(new FormData(form))}`;
}
